import React from "react";
import { FC } from "react";
import { useCallback } from "react";
import FontIcon from "../FontIcon";
import BootstrapInput from "../BootstrapInput";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  InputAdornment: {
    "& .MuiButtonBase-root:hover": {
      background: "transparent",
    },
  },
}));

const PasswordInput: FC<any> = (props) => {
  const classes = useStyles();

  const [show, setShow] = React.useState<boolean>(false);

  const toggleVisibility = useCallback(() => {
    setShow((prevState) => !prevState);
  }, [setShow]);

  return (
    <BootstrapInput
      {...props}
      type={show ? "text" : "password"}
      endAdornment={
        <InputAdornment className={classes.InputAdornment} position="end">
          <IconButton size={"small"} onClick={toggleVisibility}>
            {show ? <FontIcon name="hide" /> : <FontIcon name="show" />}
          </IconButton>
        </InputAdornment>
      }
    />
  );
};

export default React.memo(PasswordInput);
